<template>
  <svg></svg>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AdminIconProto extends Vue {
  @Prop({ default: undefined })
  color!: string | undefined;
}
</script>

<style scoped>

</style>